module.exports = __webpack_public_path__ + "img/sv70on.e199e2c1.svg";